import { useEffect } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

const ScrollToTop = () => {
    const { pathname, hash } = useLocation();
    const navType = useNavigationType();

    useEffect(() => {
        if (navType === 'POP') return;
        if (hash) {
            // Let the browser or Navigation handle hash scrolling
            setTimeout(() => {
                const el = document.getElementById(hash.slice(1));
                if (el) el.scrollIntoView({ behavior: 'smooth' });
            }, 100);
        } else {
            window.scrollTo(0, 0);
            const dashContainer = document.getElementById('dashboard-scroll-container');
            if (dashContainer) dashContainer.scrollTo(0, 0);
        }
    }, [pathname, hash, navType]);

    return null;
};

export default ScrollToTop;
